import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/getting-started/page.tsx");
